import http from "./httpService";

export function getCountries(){
    return http.get("https://suscripciones.selecciones.com.ar/countries")
}

export function getProvinces(){
    return http.get("https://suscripciones.selecciones.com.ar/provinces")
}

export function getLocation(){
    return http.get("https://get.geojs.io/v1/ip/country.json")
}
